module.exports = __webpack_public_path__ + "img/img19.2a511e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img19.jpg
// module id = 315
// module chunks = 0